$(document).ready(function(){
	if ($('body').is('.type--events, .type--schoolProgram')) {
		var url = window.location.href;
		if (url.indexOf("?fromDate=") > -1) {
			$('html, body').animate({
				scrollTop: $('.formFilter').offset().top - $('.header').outerHeight()
			}, 'slow');
		}
	}
});